import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface applicationButtonIconStyles {
  size: number;
  color: string | undefined;
  buttonStyles: React.CSSProperties;
  buttonStylesSecondary: React.CSSProperties;
}

export const useApplicationButtonIconStyles = () => {
  const { md } = useScreen();
  const { palette } = useCustomTheme();

  return {
    size: md ? 20 : 21,
    buttonStyles: {
      color: palette.secondary.main,
      padding: 5,
    },
  } as applicationButtonIconStyles;
};
